















import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppAddCustomer extends Vue {
  getRouteCustomerList() {
    return this.$router.push("/customers/customer");
  }
  add() {
    this.$store.commit("ADD_CUSTOMER_CLICK");
  }
}
